module.exports = __webpack_public_path__ + "static/media/resi03.0b357a4a.jpeg";